import { ErrorInfoIcon } from '@repo/icons';
import { Button } from '@repo/ui/button';
import { useTranslations } from 'next-intl';
import { type PaymentTypes } from '@/server-actions/payment-methods';

interface FailureMessageProps {
  paymentType: PaymentTypes;
  title: React.ReactNode;
  subTitle: React.ReactNode;
  goBack: () => void;
}

const FailureMessage = ({ paymentType, title, subTitle, goBack }: FailureMessageProps) => {
  const t = useTranslations(paymentType);

  return (
    <div className="flex size-full flex-col items-center justify-center space-y-10 text-center">
      <div className="flex w-full flex-col items-center justify-center gap-y-3 vt-colors-statuses-fail-default">
        <div className=" flex h-10 w-10 items-center justify-center rounded-full text-center vt-surface-darker-bg">
          <ErrorInfoIcon className="size-[20px]" />
        </div>
        <h1 className="vt-font-highlight vt-text-size-biggest sm:vt-text-size-biggest-sm">{title}</h1>
        <h2 className="vt-text-size-medium sm:vt-text-size-medium-sm">{subTitle}</h2>
      </div>
      <div className="flex items-center justify-center">
        <Button
          variant="secondary"
          onClick={goBack}
        >
          <span>{t('try-again')}</span>
        </Button>
      </div>
    </div>
  );
};

export default FailureMessage;
